import { redirectToLogin } from "../annoucement-sheet";
import { api } from "../api";
import authHeader from "../auth-header";
export interface IServicePageInfoData {
    "page": IServiceDataInfo,
    "page_service_section":any;
}
export interface IServiceDataInfo {
    "id": number,
    "sub_menu_id": number,
    "menu_id": number,
    "slug": string,
    "title_en": string,
    "title_tc": string,
    "title_sc": string,
    "meta_title_en": string,
    "meta_title_tc": string,
    "meta_title_sc": string,
    "meta_description_en": string,
    "meta_description_tc": string,
    "meta_description_sc": string,
    "meta_image": string,
    "banner_mobile_image": string,
    "banner_desktop_image": string,
}

export type TData = {
    data: [];
    total: number;
};
export type PaginationData = {
    page: number;
    limit: number | string | undefined;
    search: string | number;
    sort?: string;
    type?: string;
};
export const jobCategoryApi = api.injectEndpoints({
    endpoints: (build) => ({
        fetch_jobcategory_opening: build.query<TData, PaginationData>({
            query: ({ limit, page, search,type, sort }) => ({
                url: `category/fetch?per_page=${limit}&page=${page}&search=${search}&sort=${sort??''}`,
                headers: authHeader()
            }),
            keepUnusedDataFor: 0,
            transformErrorResponse: (err) => {
                if (err?.status === 401) {
                    redirectToLogin();
                }
            },
            providesTags: () => [{ type: "JobCategory" as const, id: "LIST" }]
        }),
        fetch_jobcategory_opening_info: build.mutation<TData, PaginationData>({
            query({ limit, page, search, type, sort }) {
                return {
                    headers: authHeader(),
                    url: `category/fetch?per_page=${limit}&page=${page}&search=${search}&sort=${sort??''}`,
                    method: "GET",
                };
            },
            invalidatesTags: ['JobCategory']
        }),
        deleteJobcategory: build.mutation<TData, number>({
            query(body) {
                return {
                    headers: authHeader(),
                    url: `category/delete`,
                    body: {
                        id: body
                    },
                    method: "POST",
                };
            },
            invalidatesTags: ['JobCategory']
        }),
    })
});

export const { useFetch_jobcategory_openingQuery,useFetch_jobcategory_opening_infoMutation,useDeleteJobcategoryMutation } = jobCategoryApi;

export const {
    endpoints: { fetch_jobcategory_opening,fetch_jobcategory_opening_info,deleteJobcategory }
} = jobCategoryApi;
